<template>
  <div class="task-container">
    <div class="row col-md-12">
      <table id="accountNotesTable" class="table table-striped table-hover">
        <thead>
        <th class="text-center">Service Type</th>
        <th class="text-center" >Task Type</th>
        <th class="text-center">Domain</th>
        <th class="text-center">Priority</th>
        <th class="text-center">Assign</th>
        <th class="text-center">Comment</th>
        <th class="text-center">Admin notes</th>
        <th class="text-center">Service Id</th>
        <th class="text-center">Created At</th>
        <th class="text-center">Checkin</th>
        <th class="text-center">Action</th>
        </thead>
        <tbody>
        <tr v-for="(row, index) of getTasks" :key="index">
          <td class="text-center">
            <span class="badge badge-info">{{ row.type || '' }}</span><br>
            <span v-if="row.linkedTask" class="badge badge-danger">Interlinked Task</span>
          </td>
          <td class="text-center">
            {{ row.taskType }}
          </td>
          <td class="text-center">
            {{ row.domain }}
          </td>
          <td class="text-center">
            <span class="badge" :class="row.priority === 'high' ? 'badge-danger' : row.priority === 'medium' ? 'badge-warning' : 'badge-success'">{{ row.priority }}</span>
          </td>
          <td class="text-center">
            <div class="photo">
              <img :title="row.assign.name" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.assign.email)}?s=45`"/>
            </div>
          </td>
          <td class="text-center"><span v-html="getComment(row, 'comments')"></span>
            <template v-if="row.taskList" ><br><span class="text-primary ml-5">View task List</span><i title="View Task Details" class=" fa fa-eye ml-5 text-primary" @click="openTaskModal(row, false, true)" ></i></template>
            <br>
            <span class="text-primary make-cursor-pointer" v-if="row.linkedTask" @click="openTaskModal(row, true, true)">View Parent Task</span>
          </td>
          <td ><span v-html="getComment(row, 'notes')"></span></td>
          <td class="text-center">
            <template v-if="row.hbServiceId && row.hbServiceId.length===1">
              <a v-for="(row1, index) in row.hbServiceId" :key="index" target="_blank" :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${row1}`">{{row1}}</a>
            </template>
            <template v-if="row.hbServiceId && row.hbServiceId.length!==1">
              <a v-for="(row1, index) in row.hbServiceId" :key="index" target="_blank" :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${row1}`">{{row1 + ', '}}</a>
            </template>
          </td>
          <td class="text-center"><span class="badge badge-info">{{row.createdAt | formatDate}}</span></td>
          <td class="text-center">
            <button v-if="!row.checkinBy" class="btn btn-primary btn-sm mr-2" @click="row.checkinBy = `${user.firstName} ${user.lastName}`;checkin(row)">
              <div class="loader mini_loader" v-if="selectedId === row.id && action === 'checkin'"></div>
              <span> checkin</span>
            </button>
            <template v-else>
              <span  class="badge badge-pill badge-success">
                {{ row.checkinBy }}
                <a href="javascript:void(0)" @click="checkoutTask(row)" class="fa fa-times text-white"></a>
              </span>
            </template>
          </td>
          <td class="text-center">
            <button  class="btn btn-primary btn-sm mr-2" @click="openTaskModal(row, false, false)">
              <i title="View Task Details" class=" fa fa-eye ml-2"></i>
            </button>
            <button title="Edit" class="btn btn-primary btn-sm mr-2" data-toggle="modal"  @click="fixModal(row)" data-target="#456"><i class="fa fa-pencil fa-sm"></i></button>
            <button v-if="!row.resolvedAt" :disabled="!row.checkinBy || row.resolvedAt" class="btn btn-primary btn-sm mr-2"  @click="resolveTask(row)">
              <div class="loader mini_loader" v-if="selectedId === row.id && action === 'resolve'"></div>
              <span v-else><i class="fa fa-refresh"></i> Resolve</span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ this.pageCount }}
                </span>
        <section class="dataTables_paginate paging_full_numbers">
          <paginate
              ref="paginate"
              :pageCount="pageCount"
              :clickHandler="goToPage"
              :prevText="'Prev'"
              :nextText="'Next'"
              page-class="page-item"
              prev-class="page-item"
              prev-link-class="page-link"
              next-class="page-item"
              next-link-class="page-link"
              page-link-class="page-link"
              containerClass="pagination">
          </paginate>
        </section>
      </div>
    </div>
    <div class="modal fade commentModal" id="commentModal" tabindex="-1" role="dialog" aria-labelledby="commentModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <form @submit.prevent="submitComment">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Add Comment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Comments*</label>
                <textarea v-model="newTask.comment" class="form-control" rows="4" required></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeCommentModal">Close</button>
              <button type="submit" class="btn btn-primary" >
                <div class="loader small_loader" v-if="adding"></div>
                <span v-else>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <manual-task-modal :parent-type="parentType" ref="createModal"  modalId= "4426"/>
    <manual-task-detail-modal ref="taskListModal" :parentTaskDetails="parentTaskDetails" id="viewTicketModalManualTask" :showTaskList="showTaskList"/>
  </div>
</template>

<script>
import {db, storage} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import swal from "sweetalert2";
import md5 from "crypto-js/md5";
import statisticsMixin from "@/mixins/statisticsMixin";
import ManualTaskModal from "@/components/Admin/Sales/ManualTaskModal.vue";
import ManualTaskDetailModal from "@/components/Admin/Sales/ManualTaskDetailModal.vue";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";

export default {
  name: "task-notes",
  mixins: [statisticsMixin],
  components: {
    ManualTaskModal,
    Paginate,
    PerfectScrollbar,
    ManualTaskDetailModal
  },
  mounted() {
    console.log('inside mounted');
  },
  data() {
    return {
      newTask: {
        priority: 'low',
        ticketUrl: '',
        assign: {
          firstName: '',
          lastName: '',
          docID: '',
          email: ''
        },
        taskType: '',
        selectedUser: {
          firstName: null,
          lastName: null,
          clientId: null,
          id: null,
          email: null
        },
        clientEmail: null,
        clientId: null,
        selectedDomain: null,
        clientHostBillId: null,
        comment: '',
      },
      selectedSalesToSupportTask: {},
      showTaskList: true,
      action: '',
      selectedId: null,
      pageNumber: 0,
      showRecords: 3,
      loading: false,
      selectedIndex: -1,
      limit: {
        prev: null,
        curr: null
      },
      parentTaskDetails: {mainText: ''},
      adding: false,
      parentType: '',
    }
  },
  watch: {
    accountNotes() {
      this.pageNumber = 0;
      this.$refs.paginate.innerValue = 1;
    }
  },
  computed: {
    getTasks() {
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      return this.accountNotes.slice(start, end);
    },
    pageCount() {
      let l = parseInt(this.accountNotes.length), s = parseInt(this.showRecords);
      return Math.ceil(l / s);
    },
  },
  props: {
    docId: {
      type: String
    },
    accountNotes: {
      type: Array
    }
  },
  methods: {
    fixModal(link = null) {
      this.parentType = link.type
      this.$refs.createModal.fixModal(link)
    },
    getComment(link, type) {
      let comment = null;
      if (type === 'comments') {
        comment = link.linkedTask ? link.linkedTask.comment : link.comment
      }
      if (type === 'notes') {
        comment = link.linkedTask ? link.comment : ''
      }
      let str = comment ? comment.split('\\n').join('<br>') : '';
      return str ? str.split('"').join('') : ''
    },
    closeCommentModal() {
      this.newTask = {
        priority: 'low', ticketUrl: '', assign: '', taskType: '', selectedUser: {}, clientHostBillId: null, comment: ''
      }
      $('#commentModal').modal('hide');
    },
    async submitComment() {
      try {
        console.log('comment', this.selectedSalesToSupportTask)
        this.adding = true;
        await this.resolve(this.selectedSalesToSupportTask);
        const ref = await db.collection('manualTasks').add({
          assign: {
            name: '',
            uid: '',
            email: ''
          },
          limit: this.limit,
          linkedTask: this.selectedSalesToSupportTask,
          hostBillID: this.selectedSalesToSupportTask.hostBillID,
          hbServiceId: this.selectedSalesToSupportTask.hbServiceId,
          serviceType: this.selectedSalesToSupportTask.serviceType,
          clientId: this.selectedSalesToSupportTask.clientId,
          comment: JSON.stringify(this.newTask.comment),
          domain: this.selectedSalesToSupportTask.domain,
          priority: this.selectedSalesToSupportTask.priority,
          taskType: this.selectedSalesToSupportTask.taskType,
          ticketURL: this.selectedSalesToSupportTask.ticketURL,
          resolved: false,
          type: this.selectedSalesToSupportTask.type === 'support' ? 'sales' : 'support',
          lastMessageSentAt: new Date().toISOString(),
          createdBy: `${this.user.firstName} ${this.user.lastName}`,
          createdAt: new Date().toISOString(),
        });
        const response = await this.$http.post('/utilities/send_manual_task_to_slack', {
          grant_type: 'token',
          assign: {
            name: '',
            uid: '',
            email: ''
          },
          type: this.selectedSalesToSupportTask.type === 'support' ? 'sales' : 'support',
          taskType: this.selectedSalesToSupportTask.taskType,
          priority: this.newTask.priority,
          comment: this.newTask.comment,
          domain: this.selectedSalesToSupportTask.domain,
          createdBy: this.user.firstName + ' ' + this.user.lastName,
          taskId: ref.id
        });
        console.log('res', response)
        $("#commentModal").modal('hide');
      } catch (e) {
        console.log("comment modal submission error", e);
      } finally {
        this.adding = false;
      }

    },
    async resolve(task) {
      try {
        await db.collection('manualTasks')
            .doc(task.id)
            .update({
              resolvedBy: `${this.user.firstName} ${this.user.lastName}`,
              resolvedAt: new Date().toISOString(),
              resolved: true
            });
        try {
          await this.$http.post('/utilities/update_manual_task_to_slack', {
            grant_type: 'token',
            ...task,
            resolvedBy: `${this.user.firstName} ${this.user.lastName}`,
            actionType: 'resolve'
          });
        } catch (e) {
          console.log(e.toString())
        }
        this.selectedId = null;
        try {
          await this.incrementCountBasedOnType(this.user, 'support')
          console.log('this task', task)
          await this.addRecentActivity({
            type: 'info',
            actionType: `Manual ${task.type} Task`,
            message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${this.user.firstName} ${this.user.lastName}.`,
            customer: {
              email: task.hostBillID,
              domain: task.domain,
            }
          })
          await this.removeAdminActiveTask({taskId: task.id})

        } catch (e) {
          console.log('line 512', e.toString())
        }
        this.$emit('refresh');
        // this.tasks = this.tasks.filter(el => el.id !== task.id)
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Something went wrong while resolving task', 'error')
      }

    },
    async checkin(task) {
      this.selectedId = task.id;
      this.action = 'checkin';
      await db.collection('manualTasks').doc(task.id).update({
        checkinBy: `${this.user.firstName} ${this.user.lastName}`,
        checkinByEmail: this.user.email
      });
      this.selectedId = null;
      this.action = null
      const data = {
        taskId: task.id,
        ticketId: null,
        type: 'info',
        actionType: `Manual ${task.type} Task`,
        message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
        customer: {
          email: task.hostBillID,
          domain: task.domain,
        }
      }
      await this.addRecentActivity({...data})
      await this.addToAdminActiveTask({...data})
      try {
        await this.$http.post('/utilities/update_manual_task_to_slack', {
          grant_type: 'token',
          ...task,
          checkinBy: `${this.user.firstName} ${this.user.lastName}`,
          checkinByEmail: this.user.email
        });
      } catch (e) {
        console.log('error from updating manual task', e.toString())
      }
      swal('Success', 'You have successfully checked into this task', 'success');
    },
    async checkoutTask(task) {
      try {
        task.checkinBy = '';
        task.checkinByEmail = '';
        await db.collection('manualTasks').doc(task.id).update({checkinBy: '', checkinByEmail: ''})
        const data = {
          taskId: task.id,
          ticketId: null,
          type: 'info',
          actionType: `Manual ${task.type} Task`,
          message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been checked out by ${this.user.firstName} ${this.user.lastName}.`,
          customer: {
            email: task.hostBillID,
            domain: task.domain,
          }
        }
        await this.addRecentActivity({...data});
        await this.removeAdminActiveTask({...data})
      } catch (e) {
        console.log('something went wrong while checking out')
        swal('Error', 'Something went wrong while checking out!' + e.toString(), 'error');

      }
    },
    resolveTask(task) {
      try {
        this.selectedId = task.id;
        this.action = 'resolve';
        if (task.linkedTask) {
          this.resolve(task);
          return;
        }
        let buttonHtml = '<div>' +
            '<div>Do you want to create interlinked task for this task? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Resolve</button></li>' +
            '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Create</button></li>' +
            '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        const self = this;
        swal({
          title: "Interlinked Task!",
          html: buttonHtml,
          type: 'question',
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: function () {
            /* eslint-disable */
            $('.sw_butt2').on('click', function () {
              self.fixCommentModal(task)
              swal.close();
            });
            $('.sw_butt1').on('click', function () {
              self.resolve(task)
              swal.close();
            });
            $('.sw_butt3').on('click', function () {
              swal.close();
            });
            /* eslint-enable */
          }
        });
      } catch (e) {
        console.log(e.toString())
      } finally {
        this.selectedId = -1;
        this.action = ''
      }
    },
    fixCommentModal(task) {
      /* eslint-disable */
      this.selectedSalesToSupportTask = task;
      this.newTask.comment = "";
      $("#commentModal").modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    openTaskModal(link, isLinkedTask, showTaskList) {
      console.log(link, showTaskList)
      if (isLinkedTask) {
        this.parentTaskDetails = link.linkedTask
        this.showTaskList= showTaskList
        this.parentTaskDetails.mainText = 'Parent Task Details';
      } else {
        this.parentTaskDetails = link;
        this.showTaskList= showTaskList
        this.parentTaskDetails.mainText = 'Manual Task Details';
      }
      this.$refs.taskListModal.showRemainingTaskList = false;
      $("#viewTicketModalManualTask").modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    emailHashGravatar(email) {
      return email ? md5(email.trim().toLowerCase()).toString() : ''
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum - 1;
    },
  }
}
</script>

<style scoped>

</style>
